export function HireGradientTop() {
  return (
    <div
      style={{
        background:
          "linear-gradient(color-mix(in srgb, var(--color-light) 60%, transparent) 0%, color-mix(in srgb, var(--color-light) 0%, transparent) 100%), linear-gradient(269.24deg, rgb(249, 191, 34) 0%, rgb(145, 82, 4) 100%)",
      }}
      className={"top-0 left-0 right-0 h-full z-0 absolute"}
    >
      <div
        style={{
          background:
            "linear-gradient(0deg, var(--color-brand-light) 0%, color-mix(in srgb, var(--color-brand-light) 0%, transparent) 100%)",
        }}
        className={"top-20 left-0 right-0 bottom-0 z-0 absolute"}
      ></div>
    </div>
  );
}
